import TopNavigation from "@/components/TopNavigation.vue";
import AppFeedback from "@/components/AppFeedback.vue";
import GlobalMusicPlayer from "@/components/GlobalMusicPlayer.vue";
import PageScrollRope from "@/components/PageScrollRope.vue";
export default {
  components: {
    TopNavigation,
    AppFeedback,
    GlobalMusicPlayer,
    PageScrollRope
  },
  computed: {
    isMagazineRoute() {
      return ["home", "articleList", "ArticleDetail", "writeArticle", "editArticleById", "personalCenter", "LoginPage", "imgWall", "music", "tools", "systemManage", "error", "notFound"].includes(this.$route.name);
    },
    isStudioRoute() {
      return ["writeArticle", "editArticleById"].includes(this.$route.name);
    },
    isMusicRoute() {
      return this.$route.name === "music";
    },
    showArticleScrollRope() {
      return ["articleList", "ArticleDetail", "writeArticle", "editArticleById"].includes(this.$route.name);
    }
  }
};